import BrowseAlbums from './routes/BrowseAlbums.vue';
import BrowseTracks from './routes/BrowseTracks.vue';
import BrowseComposers from './routes/BrowseComposers.vue';
import BrowseArtists from './routes/BrowseArtists.vue';
import BrowseEnsembles from './routes/BrowseEnsembles.vue';
import BrowseExclusives from './routes/BrowseExclusives.vue';
import ViewAlbum from './routes/ViewAlbum.vue';
import ViewComposer from './routes/ViewComposer.vue';
import ViewEnsemble from './routes/ViewEnsemble.vue';
import ViewArtist from './routes/ViewArtist.vue';
import Queue from './routes/Queue.vue';
import Home from './routes/Home.vue';
import Welcome from './routes/Welcome.vue';
import NotFound from './routes/NotFound.vue';
import AuthShopify from './routes/AuthShopify.vue';
import NewAlbums from './routes/NewAlbums.vue';
import Account from './routes/Account.vue';
import Search from './routes/Search.vue';
import SearchAlbums from './routes/SearchAlbums.vue';
import SearchComposers from './routes/SearchComposers.vue';
import SearchArtists from './routes/SearchArtists.vue';
import SearchEnsembles from './routes/SearchEnsembles.vue';
import SearchTracks from './routes/SearchTracks.vue';


export default [

    { path: '/', component: Welcome },

    { path: '/account', component: Account },

    { path: '/queue', component: Queue },

    { path: '/browse', component: Home },

    { path: '/browse/albums', component: BrowseAlbums },
    { path: '/browse/albums/:id', component: ViewAlbum },

    { path: '/browse/tracks', component: BrowseTracks },

    { path: '/browse/composers', component: BrowseComposers },
    { path: '/browse/composers/:id', component: ViewComposer },
    { path: '/browse/composers/:id/:view', component: ViewComposer },

    { path: '/browse/ensembles', component: BrowseEnsembles },
    { path: '/browse/ensembles/:id', component: ViewEnsemble },
    { path: '/browse/ensembles/:id/:view', component: ViewEnsemble },

    { path: '/browse/artists', component: BrowseArtists },
    { path: '/browse/artists/:id', component: ViewArtist },
    { path: '/browse/artists/:id/:view', component: ViewArtist },

    { path: '/browse/exclusive', component: BrowseExclusives },

    { path: '/browse/new', component: NewAlbums },

    { path: '/search', component: Search },

    { path: '/search/albums', component: SearchAlbums },
    { path: '/search/composers', component: SearchComposers },
    { path: '/search/ensembles', component: SearchEnsembles },
    { path: '/search/artists', component: SearchArtists },
    { path: '/search/tracks', component: SearchTracks },

    { path: '/auth/shopify', component: AuthShopify },


    { path: '*', component: NotFound },

];



// WEBPACK FOOTER //
// ./src/routes.js